// extracted by mini-css-extract-plugin
module.exports =  {"image":"V9AK6Eo"};